var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-details--shop-client flex-between-start fsize-12" },
    [
      _c("div", { staticClass: "shop-details color-grey2" }, [
        _c(
          "div",
          { staticClass: "color-grey1 text-uppercase mb-15 text-bold" },
          [_vm._v("Infos établissement")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--name mb-5" }, [
          _c("a", { attrs: { href: _vm.order.shop.ShopId } }, [
            _vm._v(_vm._s(_vm.shop.DefaultName)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--phone mb-5" }, [
          _vm._v("\n                    Tel: "),
          _c("a", { attrs: { href: "tel:" + _vm.shop.Tel } }, [
            _vm._v(_vm._s(_vm.shop.Tel)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _vm._v(
            "\n                    Adresse: " +
              _vm._s(_vm.shop.Address1) +
              " " +
              _vm._s(_vm.shop.Address2) +
              ",\n                "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--city mb-5" }, [
          _vm._v(
            "\n                    " +
              _vm._s(_vm.shop.Zip) +
              " " +
              _vm._s(_vm.shop.City) +
              "\n                "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.order.client
        ? _c("div", { staticClass: "client-details color-grey2 text-right" }, [
            _c(
              "div",
              { staticClass: "color-grey1 text-uppercase mb-15 text-bold" },
              [_vm._v("Infos client")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "client-details--name mb-5" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.order.client.FirstName) +
                  " " +
                  _vm._s(_vm.order.client.LastName) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "client-details--phone mb-5" }, [
              _c("a", { attrs: { href: "tel:" + _vm.order.client.Mobile } }, [
                _vm._v(_vm._s(_vm.order.client.Mobile)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "client-details--mail mb-5" }, [
              _c("div", [
                _c(
                  "a",
                  { attrs: { href: "mailto:" + _vm.order.client.Email } },
                  [_vm._v(_vm._s(_vm.order.client.Email))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "client-details--date mb-5" }, [
              _c("div", [
                _vm._v("le " + _vm._s(_vm.utcToLocal(_vm.order.OrderDate))),
              ]),
            ]),
            _vm._v(" "),
            _vm.order.email_state_info
              ? _c("div", { staticClass: "mb-5 text-danger" }, [
                  _c("div", [_vm._v("Erreur à l'envoi du mail")]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "client-details color-grey2 text-right" }, [
            _vm.order.email_state_info
              ? _c("div", { staticClass: "mb-5 text-danger" }, [
                  _c("div", [_vm._v("Erreur à l'envoi du mail")]),
                ])
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }